import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { toast } from 'react-toastify';
import BadgeWrapper from '../../../Inventory/components/BadgeWrapper';
import { QuantityHandler } from '../../../Components';


// Utility function to fix floating point precision issues
const roundToThreeDecimals = (num) => {
  return Math.round((num + Number.EPSILON) * 1000) / 1000;
};

const ProductCard = ({
  imageUrl,
  name,
  price,
  quantity,
  onQuantityChange,
  badgeText,
  maxQuantity,
}) => {
  const isMobile = useMediaQuery('(max-width:1200px)');
  const [inputValue, setInputValue] = useState(quantity.toString());
  useEffect(() => {
    setInputValue(quantity.toString());
  }, [quantity]);

  const handleIncrease = () => {
    const currentValue = parseFloat(inputValue) || 0;
    const newValue = roundToThreeDecimals(currentValue + 1);
    
    // Check if maxQuantity is set and would be exceeded
    if (maxQuantity !== undefined && newValue > maxQuantity) {
      toast.error(`Maximum quantity limit of ${maxQuantity} reached for this product.`);
      return; // Don't increase if it would exceed maxQuantity
    }
    
    setInputValue(newValue.toString());
    onQuantityChange(newValue);
  };

  const handleDecrease = () => {
    const currentValue = parseFloat(inputValue) || 0;
    if (currentValue > 0) { // Minimum quantity 0
      const newValue = roundToThreeDecimals(Math.max(0, currentValue - 1));
      setInputValue(newValue.toString());
      onQuantityChange(newValue);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^\d*\.?\d{0,3}$/.test(value)) {
      setInputValue(value);
    }
  };

  const handleInputBlur = () => {
    const numericValue = parseFloat(inputValue);
    if (isNaN(numericValue) || numericValue < 0) {
      setInputValue('0');
      onQuantityChange(0);
    } else {
      const roundedValue = roundToThreeDecimals(numericValue);
      setInputValue(roundedValue.toString());
      onQuantityChange(roundedValue);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleInputBlur();
    }
  };

  return (
    <BadgeWrapper badgeText={badgeText}>
      <Box sx={{ display: 'flex', alignItems: 'center', borderTop: '1px solid #D9D9D9', pt: 2 }}>
        <Box component="img" src={imageUrl} alt={name} sx={{ width: 60, height: 60, borderRadius: 1, mr: 2 }} />
        <Box flexGrow={1}>
          <Typography variant='body1'>{name}</Typography>
          <Typography variant="body1" sx={{ color: '#8C8C8C'}}>₹ {price}</Typography>
        </Box>
        <QuantityHandler
          value={inputValue}
          onIncrease={handleIncrease}
          onDecrease={handleDecrease}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          onKeyPress={handleKeyPress}
          variant={isMobile ? "small" : "medium"}
          increaseDisabled={maxQuantity !== undefined && parseFloat(inputValue) >= maxQuantity}
        />
      </Box>
    </BadgeWrapper>
  );
};

export default ProductCard;
